import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { useDispatch, useSelector } from "react-redux";
import { getFile } from "../../../../services/restAPI/RestApi";
import "./../AdvertisementList/advertisementListSettings.less";
import { useIntl } from "react-intl";
import { isHoppyOrGamification, showName, validateTranslations } from "@util/Scripts";
import { useWidgetSettings } from "@util/customHooks";
import { Input, Message, Switch, Button, Checkbox } from "../../../BP2Components";
import { buttonTypeValues } from "../../../BP2Components/Button/Button";
import "./buttonSettings.less";
import "../GlobalSettings/GlobalSettings.less";
const { Option } = Select;

const BUTTON_TYPES_WITH_CONTENT = ["ICON_TOP", "ICON_SIDE_ARROW"];

const ButtonSettings = ({ value, data }) => {
   const dispatch = useDispatch();
   const intl = useIntl();
   const { settings, setSettings, syncTranslations } = useWidgetSettings(value, {
      sync: [
         { keyField: "btnTitle", category: "button.name", valuePrefix: "name" },
         {
            keyField: "contentKey",
            category: "button.content",
            valuePrefix: "content",
            condition: (s) => BUTTON_TYPES_WITH_CONTENT.includes(s.btnType),
         },
      ],
      translations: [
         { translationKey: value.btnTitle },
         { translationKey: value.contentKey, prefix: "content" },
      ],
   });
   const [deletePhoto, setDeletePhoto] = useState();
   const [boardLinks, setBoardLinks] = useState();
   const [fileId, setFileId] = useState(null);
   const [customUrl, setCustomUrl] = useState();
   const handleCustomUrl = (checked) => {
      setCustomUrl(checked);
   };
   const handleSwitch = (checked, name) => {
      setSettings({ ...settings, [name]: checked });
   };
   useEffect(() => {
      setDeletePhoto(value.imageFileId);
      getFile(value.imageFileId).then((res) => setFileId(res.data));
   }, []);
   const boards = useSelector(({ user }) => user.boards);
   const { allLanguages } = useSelector(({ settings }) => settings);
   const btnTypes = ["BASIC", "ICON_TOP", "ICON_SIDE_ARROW"];
   useEffect(() => {
      let userBoards = [];
      // Prepare list with board objects like {url, name} to map them as select options
      if (boards) {
         boards.forEach((board) => {
            if (board.sheets) {
               if (board.sheets.length === 1) {
                  userBoards.push({
                     url: `/boards/${board.id}/${board?.sheets?.[0]?.id}`,
                     name: `${board.name}`,
                  });
               } else {
                  board.sheets.forEach((sheet) => {
                     userBoards.push({
                        url: `/boards/${board.id}/${sheet.id}`,
                        name: `${board.name} - ${sheet.name}`,
                     });
                  });
               }
            }
         });
      }
      // Check if API saved board url is in option list. If it's not it must be a customUrl.
      let savedUrlFoundInUserBoards = false;
      userBoards.forEach((board) => {
         if (board.url === value.btnUrl) {
            savedUrlFoundInUserBoards = true;
         }
      });
      // If url is "" then we know that it's new buttonWidget's basic value so we want to give select input to users
      if (value.btnUrl === "") {
         setCustomUrl(false);
      } else {
         setCustomUrl(!savedUrlFoundInUserBoards);
      }

      setBoardLinks(userBoards);
   }, []);

   const handleSubmit = async (e) => {
      e.preventDefault();

      const validTranslations = validateTranslations(settings);

      if (!validTranslations) {
         Message.error(intl.formatMessage({ id: "widget.invalidTranslations" }));
         return;
      }

      dispatch(setWidgetInSheetParams(settings));
      try {
         await syncTranslations(settings);
         Message.success(intl.formatMessage({ id: "global.saved" }));
      } catch (err) {
         console.error("Translation sync failed:", err);
         Message.error(intl.formatMessage({ id: "settings.error" }));
      }
   };
   useEffect(() => {
      const updates = {};
      const fields = [
         { prefix: "name", translationKey: value.btnTitle },
         { prefix: "content", translationKey: value.contentKey },
      ];
      allLanguages.forEach((item) => {
         fields.forEach(({ prefix, translationKey }) => {
            const key = `${prefix}${item.language}`;
            const val = settings[key];
            if (typeof val === "object" || val === undefined) {
               updates[key] = "";
            } else if (typeof val !== "string") {
               updates[key] = showName(item.language, translationKey, data);
            }
         });
      });
      if (Object.keys(updates).length > 0) {
         setSettings((prev) => ({ ...prev, ...updates }));
      }
   }, [settings, allLanguages]);

   const handleChange = (e, name) => {
      const optionName = e?.target?.name ?? name;
      const optionValue = e?.target ? e.target.value : e;

      if (e && e.target && typeof e.target.value !== "undefined") {
         setSettings({ ...settings, [optionName]: optionValue });
      } else if (typeof e !== "object") {
         // Handle cases where `e` might be a direct value, not an event
         setSettings({ ...settings, [name]: e });
      }
   };
   const handleChangeRunProcessOnly = (val, event) => {
      setSettings({ ...settings, [event.target.name]: val });
   };
   const handleChangeElementId = (event) => {
      setSettings({ ...settings, [event.target.name]: event.target.value });
   };
   const handleEditListBuilder = () => {
      if (settings.formId) {
         window.open(`/listbuilder?tab=formbuilder&formId=${settings.formId}`, "_blank");
      } else {
         Message.warning(intl.formatMessage({ id: "forms.selectForm" }) || "Please select a form first");
      }
   };
   const handleChangeInput = (name) => (value) => {
      setSettings({ ...settings, [name]: value });
   };

   const setCorrectBoardName = (boardName) => {
      if (boardName.indexOf(" - ") !== -1) {
         return boardName.substring(boardName.indexOf(" ") + 3);
      } else {
         return boardName;
      }
   };
   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div key="btnSet" className="widget-settings__inner">
                  <label key="btnType" className="widget-settings__inner__label">
                     <IntlMessages id="settings.btnType" />:
                     <Select
                        showSearch
                        type="btnType"
                        name="btnType"
                        onChange={(e) => handleChange(e, "btnType")}
                        defaultValue={value.btnType || btnTypes[0]}
                        dropdownClassName="form-dropdown"
                        style={{ width: "300px" }}
                     >
                        {btnTypes.map((btnType) => {
                           return (
                              <Option value={btnType} key={btnType}>
                                 <IntlMessages id={`settings.btnType.${btnType}`} />
                              </Option>
                           );
                        })}
                     </Select>
                  </label>
                  <label key="title" className="widget-settings__inner__label">
                     <IntlMessages id="settings.buttonTitleTranslationKey" />:
                     <Input
                        type="btnTitle"
                        className="btnTitle"
                        name="btnTitle"
                        defaultValue={value.btnTitle}
                        onChange={handleChange}
                        style={{ width: "300px" }}
                     />
                  </label>
                  {allLanguages.map((item) => (
                     <label
                        key={`translation${item.language}`}
                        className="widget-settings__inner__label"
                     >
                        <IntlMessages id={`widgetTitle${item.language}`} />:
                        <Input
                           type="translation"
                           className="translationName"
                           name={`name${item.language}`}
                           defaultValue={
                              settings[`name${item.language}`]
                                 ? settings[`name${item.language}`]
                                 : showName(`${item.language}`, value.btnTitle, data)
                           }
                           onChange={handleChange}
                           style={{ width: "300px" }}
                        />
                     </label>
                  ))}
                  {(settings.btnType === btnTypes[1] || settings.btnType === btnTypes[2]) && (
                     <>
                        <label key="contentKey" className="widget-settings__inner__label">
                           <IntlMessages id="settings.buttonContentTranslationKey" />:
                           <Input
                              type="contentKey"
                              name="contentKey"
                              defaultValue={value?.contentKey}
                              onChange={handleChange}
                              style={{ width: "300px" }}
                           />
                        </label>
                        {allLanguages.map((item) => (
                           <label
                              key={`translationContent${item.language}`}
                              className="widget-settings__inner__label"
                           >
                              <IntlMessages id={`btnContent${item.language}`} />:
                              <Input
                                 type="translationContent"
                                 name={`content${item.language}`}
                                 defaultValue={
                                    settings[`content${item.language}`]
                                       ? settings[`content${item.language}`]
                                       : showName(`${item.language}`, value.contentKey, data)
                                 }
                                 onChange={handleChange}
                                 style={{ width: "300px" }}
                              />
                           </label>
                        ))}
                     </>
                  )}
                  <label key="openInNewTab" className="widget-settings__inner__label">
                     <IntlMessages id="button.openInNewTab" />:
                     <div className="switch_with_label">
                        <Switch
                           name="openInNewTab"
                           onChange={(e) => handleSwitch(e, "openInNewTab")}
                           defaultChecked={isHoppyOrGamification() ? true : value.openInNewTab}
                           disabled={isHoppyOrGamification()}
                        >
                           <IntlMessages id="settings.openInNewTab" />:
                        </Switch>
                     </div>
                  </label>
                  <label key="chosenOperation" className="widget-settings__inner__label">
                     <IntlMessages id="settings.chooseOperation" />:
                     <Select
                        defaultValue={value.chosenOperation}
                        style={{ width: "300px" }}
                        onChange={handleChangeInput("chosenOperation")}
                     >
                        <Option value="url">
                           <IntlMessages id="settings.url" />
                        </Option>
                        <Option value="configId" id="configIdTest">
                           <IntlMessages id="settings.configId" />
                        </Option>
                        <Option value="form">
                           <IntlMessages id="Form" />
                        </Option>
                     </Select>
                  </label>

                  {settings.chosenOperation && settings.chosenOperation === "url" ? (
                     <>
                        <label key="isCustomUrl" className="widget-settings__inner__label">
                           <IntlMessages id="settings.customUrl" />:{customUrl}
                           <div className="switch_with_label">
                              <Switch
                                 name="isCustomUrl"
                                 onChange={handleCustomUrl}
                                 checked={customUrl}
                              >
                                 <IntlMessages id="settings.customUrl" />:
                              </Switch>
                           </div>
                        </label>
                        {customUrl ? (
                           <label key="url" className="widget-settings__inner__label">
                              <IntlMessages id="settings.buttonURL" />:
                              <Input
                                 type="btnUrl"
                                 name="btnUrl"
                                 style={{ width: "500px" }}
                                 onChange={handleChange}
                                 defaultValue={value.btnUrl}
                              />
                           </label>
                        ) : (
                           <>
                              <label key="btnUrl" className="widget-settings__inner__label">
                                 <IntlMessages id="settings.buttonURL" />:
                                 <Select
                                    showSearch
                                    type="btnUrl"
                                    name="btnUrl"
                                    onChange={(e) => handleChange(e, "btnUrl")}
                                    defaultValue={value.btnUrl}
                                    dropdownClassName="form-dropdown"
                                 >
                                    {boardLinks?.map((board) => {
                                       return (
                                          <Option value={board.url} id={board.url} key={board.url}>
                                             <IntlMessages id={setCorrectBoardName(board.name)} />
                                          </Option>
                                       );
                                    })}
                                 </Select>
                              </label>
                           </>
                        )}
                     </>
                  ) : null}
                  {settings.chosenOperation && settings.chosenOperation === "configId" ? (
                     <>
                        <label key="configId" className="widget-settings__inner__label">
                           <IntlMessages id="settings.configId" />:
                           <Input
                              id="configIdWorkflow"
                              type="configId"
                              name="configId"
                              style={{ width: "100px" }}
                              onChange={handleChangeElementId}
                              defaultValue={value.configId}
                           />
                        </label>
                        <label key="runProcessOnly" className="widget-settings__inner__label">
                           <IntlMessages id="settings.runProcessOnly" />:
                           <Switch
                              name="runProcessOnly"
                              onChange={(event, name) => handleChangeRunProcessOnly(event, name)}
                              checked={settings.runProcessOnly}
                           />
                        </label>
                     </>
                  ) : null}
                  {settings.chosenOperation && settings.chosenOperation === "form" ? (
                     <>
                        <label key="formId" className="widget-settings__inner__label">
                           <IntlMessages id="settings.formId" />:
                           <div style={{ display: "flex", gap: "10px", width: "100%" }}>
                              <Input
                                 name="formId"
                                 style={{ width: "100px" }}
                                 onChange={handleChangeElementId}
                                 defaultValue={settings.formId}
                              />
                              <Button onClick={handleEditListBuilder} style={{ whiteSpace: "nowrap" }}>
                                 <IntlMessages id="global.edit" />
                              </Button>
                           </div>
                        </label>
                        <label key="dataId" className="widget-settings__inner__label">
                           <IntlMessages id="settings.dataId" />:
                           <Input
                              name="dataId"
                              style={{ width: "100px" }}
                              onChange={handleChangeElementId}
                              defaultValue={settings.dataId}
                           />
                        </label>
                        <label className="widget-settings__inner__label">
                           <IntlMessages id="button.end.modal.showEndingModal" />:
                           <Checkbox
                              onChange={(e) =>
                                 setSettings({
                                    ...settings,
                                    showEndingModal: e.target.checked,
                                 })
                              }
                              defaultChecked={settings?.showEndingModal ?? false}
                           />
                        </label>
                     </>
                  ) : null}
                  {(!settings.btnType || settings.btnType === btnTypes[0]) && (
                     <label key="btnColorType" className="widget-settings__inner__label">
                        <IntlMessages id="settings.btnColorType" />:
                        <Select
                           defaultValue={
                              buttonTypeValues.find((item) => item === value?.btnColorType)
                                 ? value?.btnColorType
                                 : "primary"
                           }
                           style={{ width: "300px" }}
                           onChange={handleChangeInput("btnColorType")}
                        >
                           {buttonTypeValues.map((type) => (
                              <Option key={type} value={type}>
                                 {type}
                              </Option>
                           ))}
                        </Select>
                     </label>
                  )}
                  <label key="buttonTypeMobile" className="widget-settings__inner__label">
                     <IntlMessages id="settings.buttonTypeMobile" />:
                     <Select
                        showSearch
                        type="buttonTypeMobile"
                        name="buttonTypeMobile"
                        onChange={(e) => handleChange(e, "buttonTypeMobile")}
                        defaultValue={value?.buttonTypeMobile}
                        dropdownClassName="form-dropdown"
                        style={{ width: "300px" }}
                     >
                        {btnTypes.map((btnType) => {
                           return (
                              <Option value={btnType} key={btnType}>
                                 <IntlMessages id={`settings.btnType.${btnType}`} />
                              </Option>
                           );
                        })}
                     </Select>
                  </label>
               </div>
               <Button key="btn" buttonType="primary" size="medium" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default ButtonSettings;
